
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appUppercase]',
  standalone: true
})
export class UppercaseDirective {
  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const upperValue = input.value.toUpperCase();
    if (input.value !== upperValue) {
      input.value = upperValue;
      input.setSelectionRange(start, end);
      input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    }
  }
}
